/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonalInfoDto
 */
export interface PersonalInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoDto
     */
    middleName: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoDto
     */
    citizenship?: string | null;
}

/**
 * Check if a given object implements the PersonalInfoDto interface.
 */
export function instanceOfPersonalInfoDto(value: object): value is PersonalInfoDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('middleName' in value) || value['middleName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function PersonalInfoDtoFromJSON(json: any): PersonalInfoDto {
    return PersonalInfoDtoFromJSONTyped(json, false);
}

export function PersonalInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'middleName': json['middleName'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'citizenship': json['citizenship'] == null ? undefined : json['citizenship'],
    };
}

  export function PersonalInfoDtoToJSON(json: any): PersonalInfoDto {
      return PersonalInfoDtoToJSONTyped(json, false);
  }

  export function PersonalInfoDtoToJSONTyped(value?: PersonalInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'middleName': value['middleName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'citizenship': value['citizenship'],
    };
}

